<template>
  <div>
    <div v-if="!vacancy">
      <p class="hr-text-muted">No vacancy selected.</p>
    </div>
    <div v-else>
      <div class="hr-mb-3"><strong>Vacancy:</strong> {{ vacancy.title }}</div>
      <div v-if="loading" class="hr-loading-state">
        <div class="hr-spinner"></div>
        <p>Loading candidates...</p>
      </div>
      <div v-else-if="candidates.length === 0" class="hr-empty-state">
        <i class="bx bx-file"></i>
        <h5>No candidates</h5>
        <p>No candidates have applied for this vacancy yet.</p>
      </div>
      <div v-else class="hr-table-wrapper">
        <table class="hr-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Candidate</th>
              <th>Email</th>
              <th style="text-align:center">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(c, i) in candidates" :key="c.id">
              <td>{{ i + 1 }}</td>
              <td>{{ c.name }}</td>
              <td>{{ c.email || '-' }}</td>
              <td style="text-align:center"><span class="hr-badge" :class="c.status === 'shortlisted' ? 'hr-badge-info' : 'hr-badge-muted'">{{ c.status }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { authUrl, execute } from "@/api";
export default {
  name: 'CandidateList',
  props: { vacancy: { type: Object, default: null } },
  data() { return { loading: false, candidates: [] }; },
  watch: {
    vacancy: { handler() { this.fetchCandidates(); }, immediate: true }
  },
  methods: {
    async fetchCandidates() {
      if (!this.vacancy || !this.vacancy.id) { this.candidates = []; return; }
      this.loading = true;
      const data = new FormData();
      data.append('function', 'getCandidatesForVacancy');
      data.append('vacancyId', this.vacancy.id);
      try {
        const res = await execute(data, authUrl);
        if (res.data.success) this.candidates = res.data.data.candidates || [];
      } catch (e) { console.error(e); }
      this.loading = false;
    }
  }
}
</script>

<style scoped>
.hr-empty-state { text-align: center; }
.hr-loading-state { text-align: center; }
</style>
